import React from 'react'
import PropTypes from 'prop-types'
import HelpHomeLink from './HelpHomeLink'
import NavigationCategoryList from './NavigationCategoryList'
import { useCategoryMetaData } from '../core'

const propTypes = {
  currentCategory: PropTypes.string,
  currentFaqPageUrl: PropTypes.string,
}

const defaultProps = {
  currentCategory: '',
  currentFaqPageUrl: '',
}

const Navigation = ({ currentCategory, currentFaqPageUrl }) => {
  const categories = useCategoryMetaData()

  function openCategoryNav(category) {
    return currentCategory === category
  }

  function isCurrentPage(slug) {
    return currentFaqPageUrl === slug
  }

  return (
    <aside className="sticky top-0 hidden w-3/12 pt-8 pb-24 pl-3 pr-6 mr-1/12 bg-primary-lightest lg:block">
      <h1 className="hidden">Browse questions</h1>
      <nav role="navigation">
        <HelpHomeLink />
        <NavigationCategoryList
          categories={categories}
          openCategoryNav={openCategoryNav}
          isCurrentPage={isCurrentPage}
          inCategoryPage={!currentFaqPageUrl}
        />
      </nav>
    </aside>
  )
}

Navigation.propTypes = propTypes
Navigation.defaultProps = defaultProps

export default Navigation
